import * as TypeGraphQL from "type-graphql";
export var InviteTokenScalarFieldEnum;
(function (InviteTokenScalarFieldEnum) {
    InviteTokenScalarFieldEnum["id"] = "id";
    InviteTokenScalarFieldEnum["token"] = "token";
    InviteTokenScalarFieldEnum["email"] = "email";
    InviteTokenScalarFieldEnum["waitlistEntryId"] = "waitlistEntryId";
    InviteTokenScalarFieldEnum["used"] = "used";
    InviteTokenScalarFieldEnum["usedAt"] = "usedAt";
    InviteTokenScalarFieldEnum["expiresAt"] = "expiresAt";
    InviteTokenScalarFieldEnum["createdAt"] = "createdAt";
})(InviteTokenScalarFieldEnum || (InviteTokenScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(InviteTokenScalarFieldEnum, {
    name: "InviteTokenScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=InviteTokenScalarFieldEnum.js.map